/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

import { postGridRequest } from '../../../services/serviceRequest';
import { useFilterContext } from '../../../context/FilterContext';
import { buildFilterServiceRequest } from '../FilterServiceRequest/utils/filterServiceRequestUtils';
import useToast from '../../../hooks/useToast';

const useSdsGrilla = () => {
  const { filter } = useFilterContext();
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  // Lazy initilization of state
  const [tab, setTab] = useState(() => {
    const localStoragetab = JSON.parse(localStorage.getItem('tab'));

    return localStoragetab || 1;
  });
  const [pageInd, setPageInd] = useState(() => {
    const localStoragePageInd = localStorage.getItem('page');

    return localStoragePageInd ? Number(localStoragePageInd) : 0;
  });
  const [data, setData] = useState([]);
  const [initialPageSize, setInitialPageSize] = useState(() => {
    const localStoragePageSize = localStorage.getItem('pageSize');

    return localStoragePageSize ? Number(localStoragePageSize) : 10;
  });
  const [savedSortBy, setSavedSortBy] = useState(() => {
    const localStorageSortBy = JSON.parse(localStorage.getItem('sortBy'));

    return localStorageSortBy || [];
  });
  const { setNewToast } = useToast();
  const isFirstRenderFilter = useRef(true);

  const getSdsGrid = async (paramsSearch, source) => {
    try {
      setLoading(true);
      const newParamsSearch = {
        ...paramsSearch,
        paginacion: {
          ...paramsSearch.paginacion,
          skip: paramsSearch.paginacion.skip + 1
        }
      };
      const { items, totalPages } = await postGridRequest(newParamsSearch, source);

      setLoading(false);
      setData(items);
      const pages = totalPages;

      setPageCount(pages);
    } catch (err) {
      if (!axios.isCancel(err)) {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
      setLoading(false);
    }
  };

  const fetchData = async ({ pageIndex, pageSize, sortBy }, source) => {
    setInitialPageSize(pageSize);
    localStorage.setItem('pageSize', pageSize);
    setSavedSortBy(sortBy);
    localStorage.setItem('sortBy', JSON.stringify(sortBy));
    const [sort] = sortBy;
    // A mapper could be made for all the elements
    const columnTypeOIMap = {
      tiposImputacion: 'TipoOI'
    };
    const sortByMap = columnTypeOIMap[sort?.id] || sort?.id;

    const configGrid = {
      skip: pageIndex,
      pageSize,
      sortColumnName: sortByMap ?? '',
      sortColumnDirection: sort?.desc ? 'desc' : 'asc'
    };

    setPageInd(pageIndex);

    const { filtersAfterSDS } = buildFilterServiceRequest(filter, configGrid, tab);

    await getSdsGrid(filtersAfterSDS, source);
  };

  useEffect(() => {
    if (isFirstRenderFilter.current) {
      isFirstRenderFilter.current = false;

      return;
    }

    // Crear Token de cancelacion
    const source = axios.CancelToken.source();

    if (initialPageSize)
      fetchData(
        {
          pageIndex: 0,
          pageSize: initialPageSize,
          sortBy: savedSortBy
        },
        source
      );

    localStorage.setItem('tab', tab);

    // Cancelar la solicitud anterior al realizar una nueva
    // eslint-disable-next-line consistent-return
    return () => source.cancel('Resquest canceled');
  }, [filter, tab]);

  useEffect(() => {
    fetchData({
      pageIndex: pageInd,
      pageSize: initialPageSize,
      sortBy: savedSortBy
    });
  }, [pageInd, initialPageSize]);

  const goToPage = (number) => {
    setPageInd(number);
  };

  const nextPage = () => {
    if (pageInd + 1 !== pageCount && pageCount !== 0) {
      setPageInd(pageInd + 1);
    }
  };

  const previousPage = () => {
    if (pageInd !== 0) {
      setPageInd(pageInd - 1);
    }
  };

  useEffect(() => {
    localStorage.setItem('page', pageInd);
  }, [pageInd]);

  return {
    data,
    loading,
    setTab,
    pageCount,
    fetchData,
    initialPageSize,
    savedSortBy,
    tab,
    pageInd,
    setPageInd,
    goToPage,
    nextPage,
    previousPage,
    setInitialPageSize
  };
};

export default useSdsGrilla;
